let API = {
	DOMAIN: 'gallery-uat-1.vphotos.cn',
	COMMON_PORXY: '//api-uat-1.vphotos.cn',
	SA_SERVER_URL: 'https://sensors.vphotos.cn:8106/sa?project=vphoto_uat',
	APPID: 'wxe41251ab73797f50'
};
export { API };
